<template>
    <div class="relative bg-gradient-to-b from-gray-50 to-white py-12 sm:py-16 overflow-hidden" :class="{ 'rounded-[20px] !py-8': minimal }">
        <div class="absolute inset-0 overflow-hidden">
            <div class="absolute -top-24 -right-24 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse"></div>
            <div
                class="absolute -bottom-24 -left-24 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-pulse delay-1000">
            </div>
        </div>

        <div class="relative mx-auto container px-6 lg:px-8 ">
            <div class="mx-auto max-w-2xl text-center" v-if="!minimal">
                <h2 class="text-3xl font-bold tracking-tight text-primary sm:text-4xl">Contactez-nous</h2>
                <p class="mt-6 text-lg leading-8 text-gray-600">
                    Une question ? N'hésitez pas à nous contacter. Notre équipe est à votre disposition.
                </p>
            </div>
            <template v-if="selectedCompany?.name != 'EasyJet'">
<div v-if="!minimal" class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                <div class="p-8 border border-gray-200 rounded-3xl bg-white">
                    <div class="flex items-start gap-4">
                        <svg class="w-6 h-6 mt-1 flex-shrink-0 text-primary" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path fill-rule="evenodd"
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <div>
                            <h3 class="font-semibold">Notre adresse</h3>
                            <p class="mt-1">UNAC Cité PN<br />Bureau 2D045 - 2e étage</p>
                        </div>
                    </div>
                </div>

                <div class="p-8 border border-gray-200 rounded-3xl bg-white">
                    <div class="flex items-start gap-4">
                        <svg class="w-6 h-6 mt-1 flex-shrink-0 text-primary" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                clip-rule="evenodd" />
                        </svg>
                        <div>
                            <h3 class="font-semibold">Horaires d'ouverture</h3>
                            <p class="mt-1">
                                Tous les jours
                                9h à 17h
                            </p>
                        </div>
                    </div>
                </div>

                <div class="p-8 border border-gray-200 rounded-3xl bg-white">
                    <!-- Contact Info -->
                    <div class="flex items-start gap-4">
                        <svg class="w-6 h-6 mt-1 flex-shrink-0 text-primary" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        <div>
                            <h3 class="font-semibold">Contactez-nous</h3>
                            <p class="mt-1">
                                <template v-if="selectedCompany?.name == 'EasyJet'">
                                    Email: <a href="mailto:easyjet@unac.asso.fr" class="text-primary">easyjet@unac.asso.fr</a><br />
                                </template>
                                <template v-else>
                                    Email: <a href="mailto:navigants@unac.asso.fr" class="text-primary">navigants@unac.asso.fr</a><br />
                                </template>
                                <template v-if="companyPhone">
                                    Tél 1: <a :href="`tel:${companyPhone.phone1}`" class="text-primary">{{ companyPhone.phone1 }}</a><br />
                                    Tél 2: <a :href="`tel:${companyPhone.phone2}`" class="text-primary">{{ companyPhone.phone2 }}</a>
                                </template>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            </template>

            <div class="grid md:grid-cols-3 gap-0 mt-8 shadow-xl rounded-3xl" :class="{ 'mt-0 !shadow-none': minimal, '': selectedCompany?.name != 'EasyJet' }">
                <div class="grid grid-cols-1 md:col-span-2 gap-8 lg:mx-0 w-full">
                    <div
                        class="relative md:rounded-l-3xl md:rounded-tr-none rounded-t-3xl bg-white p-8 ring-1 ring-gray-200 transform transition-all duration-300"
                        :class="{ '!py-4 px-0 md:px-4 !ring-0 md:!bg-white !bg-transparent !ring-transparent': minimal }"
                        >
                        <form @submit.prevent="handleSubmit" class="md:space-y-6 space-y-3">
                            <div class="md:hidden block pb-3 border-b border-gray-200">
                                <div class="flex justify-between items-center">
                                    <h2 class="text-xl font-bold text-gray-900">Contactez-nous</h2>
                                <button v-if="isPopup" @click="$emit('close')" type="button" class="text-gray-400 hover:text-gray-500">
                                    <span class="sr-only">Fermer</span>
                                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                                </div>
                            </div>
                            <div class="grid grid-cols-1 md:gap-6 gap-4 sm:grid-cols-2">
                                <div class="group sm:col-span-2">
                                    <label for="name"
                                        class="block text-sm font-medium text-gray-700 group-focus-within:text-primary transition-colors duration-300">Nom
                                        complet</label>
                                    <div class="mt-2 relative">
                                        <input v-model="contactForm.name" type="text" name="name" id="name" :class="[
                                            'block w-full rounded-xl border-0 py-3 px-4 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 transition-all duration-300',
                                            errors.name ? 'ring-red-300 focus:ring-red-500' : 'ring-gray-300 focus:ring-primary'
                                        ]" placeholder="Votre nom complet" required>
                                        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                                            <svg class="h-5 w-5 text-gray-400 group-focus-within:text-primary transition-colors duration-300"
                                                viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd"
                                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <p v-if="errors.name" class="mt-1 text-sm text-red-600">{{ errors.name }}</p>
                                </div>

                                <div class="group">
                                    <label for="email"
                                        class="block text-sm font-medium text-gray-700 group-focus-within:text-primary transition-colors duration-300">Email</label>
                                    <div class="mt-2 relative">
                                        <input v-model="contactForm.email" type="email" name="email" id="email" :class="[
                                            'block w-full rounded-xl border-0 py-3 px-4 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 transition-all duration-300',
                                            errors.email ? 'ring-red-300 focus:ring-red-500' : 'ring-gray-300 focus:ring-primary'
                                        ]" placeholder="votre@email.com" required>
                                        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                                            <svg class="h-5 w-5 text-gray-400 group-focus-within:text-primary transition-colors duration-300"
                                                viewBox="0 0 20 20" fill="currentColor">
                                                <path
                                                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <p v-if="errors.email" class="mt-1 text-sm text-red-600">{{ errors.email }}</p>
                                </div>

                                <div class="group">
                                    <label for="phone"
                                        class="block text-sm font-medium text-gray-700 group-focus-within:text-primary transition-colors duration-300">Téléphone</label>
                                    <div class="mt-2 relative">
                                        <input v-model="contactForm.phone" type="text" name="phone" id="phone" :class="[
                                            'block w-full rounded-xl border-0 py-3 px-4 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 transition-all duration-300',
                                            errors.phone ? 'ring-red-300 focus:ring-red-500' : 'ring-gray-300 focus:ring-primary'
                                        ]" placeholder="Votre numéro de téléphone">
                                        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                                class="h-5 w-5 text-gray-400 group-focus-within:text-primary transition-colors duration-300"
                                                viewBox="0 0 24 24">
                                                <path fill-rule="evenodd"
                                                    d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <p v-if="errors.phone" class="mt-1 text-sm text-red-600">{{ errors.phone }}</p>
                                </div>
                            </div>
                            <div class="group">
                                <label for="subject"
                                    class="block text-sm font-medium text-gray-700 group-focus-within:text-primary transition-colors duration-300">Sujet</label>
                                <div class="mt-2 relative">
                                    <input v-model="contactForm.subject" type="text" name="subject" id="subject" :class="[
                                        'block w-full rounded-xl border-0 py-3 px-4 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 transition-all duration-300',
                                        errors.subject ? 'ring-red-300 focus:ring-red-500' : 'ring-gray-300 focus:ring-primary'
                                    ]" placeholder="Sujet de votre message" required>
                                    <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                                        <svg class="h-5 w-5 text-gray-400 group-focus-within:text-primary transition-colors duration-300"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 14a6 6 0 110-12 6 6 0 010 12z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                                <p v-if="errors.subject" class="mt-1 text-sm text-red-600">{{ errors.subject }}</p>
                            </div>
                            <div class="group">
                                <label for="message"
                                    class="block text-sm font-medium text-gray-700 group-focus-within:text-primary transition-colors duration-300">Message</label>
                                <div class="mt-2 relative">
                                    <textarea v-model="contactForm.content" id="message" name="message" rows="4" :class="[
                                        'block w-full rounded-xl border-0 py-3 px-4 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset sm:text-sm sm:leading-6 transition-all duration-300',
                                        errors.content ? 'ring-red-300 focus:ring-red-500' : 'ring-gray-300 focus:ring-primary'
                                    ]" placeholder="Votre message..." required></textarea>
                                    <div class="absolute top-3 right-3">
                                        <svg class="h-5 w-5 text-gray-400 group-focus-within:text-primary transition-colors duration-300"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </div>
                                <p v-if="errors.content" class="mt-1 text-sm text-red-600">{{ errors.content }}</p>
                            </div>
                            <div>
                                <button type="submit"
                                    class="w-full rounded-xl bg-primary px-4 py-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary transition-all duration-300 hover:shadow-lg flex items-center justify-center gap-2"
                                    :disabled="loading">
                                    <span v-if="loading" class="inline-block animate-spin mr-2">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                                        </svg>
                                    </span>
                                    <span v-else>Envoyer le message</span>
                                    <svg v-if="!loading" class="w-5 h-5" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <template v-if="selectedCompany?.name != 'EasyJet'">
                    <div v-if="(isPopup && !isMobile) || !isPopup" >
                        <div class="w-full h-full bg-primary bg-cover bg-center rounded-b-3xl md:rounded-bl-none md:rounded-r-3xl p-8">
                            <h6 class="text-white lg:text-2xl text-xl font-bold">Nous sommes là pour vous !</h6>
                            <div class="mt-6 text-white relative">
                                <div class="space-y-8">
                                    <div class="relative bg-white rounded-2xl overflow-hidden shadow-lg ring-1 ring-gray-200 transform transition-all duration-300">
                                        <div class="relative group">
                                        <div class="overflow-hidden rounded-lg shadow-lg">
                                            <img
                                                :src="contactIllustration"
                                                alt="Emplacement du bureau UNAC"
                                                class="w-full h-auto transition-transform duration-200 cursor-zoom-in"
                                                :style="{ transform: `scale(${zoomLevel}) translate(${panX}px, ${panY}px)` }"
                                                @mousedown="startPan"
                                                @mousemove="pan"
                                                @mouseup="stopPan"
                                                @mouseleave="stopPan"
                                                @wheel.prevent="handleZoom"
                                            />
                                        </div>
                                        <div class="absolute bottom-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                            <button
                                                @click="zoomIn"
                                                class="p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 transition-colors duration-200"
                                                title="Zoom in"
                                            >
                                                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                </svg>
                                            </button>
                                            <button
                                                @click="zoomOut"
                                                class="p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 transition-colors duration-200"
                                                title="Zoom out"
                                            >
                                                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                                                </svg>
                                            </button>
                                            <button
                                                @click="resetZoom"
                                                class="p-2 bg-white rounded-lg shadow-md hover:bg-gray-50 transition-colors duration-200"
                                                title="Reset zoom"
                                            >
                                                <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="flex items-center justify-center gap-4">
                                        <template v-if="companyID == 1">
                                            <a href="https://www.facebook.com/groups/3031498563680006" target="_blank"
                                                class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-white hover:bg-primary hover:text-white transition-all duration-300">
                                                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                                    <path
                                                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                                                </svg>
                                            </a>

                                            <a href="https://www.instagram.com/unac.airfrance" target="_blank"
                                                class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-white hover:bg-primary hover:text-white transition-all duration-300">
                                                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path
                                                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                                                </svg>
                                            </a>
                                        </template>

                                        <template v-if="companyID == 2">
                                            <a href="https://www.facebook.com/groups/unacezyadherents" target="_blank"
                                                class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-white hover:bg-primary hover:text-white transition-all duration-300">
                                                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                                    <path
                                                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                                                </svg>
                                            </a>
                                        </template>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="selectedCompany?.name == 'EasyJet'">
                    <div class="w-full h-full bg-primary bg-cover bg-center rounded-b-3xl md:rounded-bl-none md:rounded-r-3xl p-8">
                        <h6 class="text-white lg:text-2xl text-xl font-bold">Nous sommes là pour vous !</h6>
                        <div class="mt-6 text-white">
                            <div class="space-y-4">
                                <!-- Email -->
                                <div class="flex items-center gap-3">
                                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <a href="mailto:easyjet@unac.asso.fr" class="hover:underline">easyjet@unac.asso.fr</a>
                                </div>

                                <!-- Social Media Links -->
                                <div class="space-y-3">
                                    <h6 class="text-white font-semibold">Retrouvez-nous sur :</h6>

                                    <!-- Facebook UNAC EZY Crewroom -->
                                    <div class="flex items-center gap-3">
                                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                        </svg>
                                        <a href="https://www.facebook.com/groups/unac.ezy.crewroom" target="_blank" class="hover:underline">UNAC EZY Crewroom</a>
                                    </div>

                                    <!-- Facebook UNAC EZY Adhérents -->
                                    <div class="flex items-center gap-3">
                                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                        </svg>
                                        <a href="https://www.facebook.com/groups/unac.ezy.adherents" target="_blank" class="hover:underline">UNAC EZY Adhérents</a>
                                    </div>

                                    <!-- Instagram -->
                                    <div class="flex items-center gap-3">
                                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                        </svg>
                                        <a href="https://www.instagram.com/unac.ezy" target="_blank" class="hover:underline">@unac.ezy</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import contactIllustration from "../../assets/images/svg/contact-illustration.svg";

import { useToast } from 'vue-toastification';
const toast = useToast();

const props = defineProps({
    minimal: {
        type: Boolean,
        default: false,
    },
    isPopup: {
        type: Boolean,
        default: false,
    },
});

const isMobile = ref(window.innerWidth < 768);

// Add event listener for window resize
window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth < 768;
});

const companyID = computed(() => {
    return JSON.parse(localStorage.getItem('selectedCompany'))?.id || 1;
})

const selectedCompany = computed(() => {
    return JSON.parse(localStorage.getItem('selectedCompany'));
})

const companyPhone = computed(() => {
    const companyId = JSON.parse(localStorage.getItem('selectedCompany'))?.id || 1;
    if(companyId == 1){
        return {
            phone1: '0141564076',
            phone2: '0141564077',
        }
    }
    return null
})


const contactForm = ref({
    name: '',
    email: '',
    phone: '',
    subject: '',
    content: '',
});

const errors = ref({
    name: '',
    email: '',
    phone: '',
    subject: '',
    content: '',
});

const loading = ref(false);
const showOfficePlacement = ref(false);

const zoomLevel = ref(1);
const panX = ref(0);
const panY = ref(0);
const isPanning = ref(false);
const lastPanX = ref(0);
const lastPanY = ref(0);

const handleSubmit = async () => {
    loading.value = true;
    try {
        const response = await axios.post('contact-us', {
            ...contactForm.value,
            company_id: companyID.value,
        });
        if (response.status === 200) {
            contactForm.value = {
                name: '',
                email: '',
                phone: '',
                subject: '',
                content: '',
                company_id: companyID.value,
            };
            errors.value = {
                name: '',
                email: '',
                phone: '',
                subject: '',
                content: '',
            };
            toast.success('Message envoyé avec succès');
        }
    } catch (error) {
        if (error.response?.status === 422) {
            errors.value = error.response.data.errors;
        } else {
            console.error('Error submitting contact form:', error);
            toast.error('Une erreur est survenue lors de l\'envoi du message');
        }
    } finally {
        loading.value = false;
    }
};

const zoomIn = () => {
    if (zoomLevel.value < 3) {
        zoomLevel.value += 0.25;
    }
};

const zoomOut = () => {
    if (zoomLevel.value > 0.5) {
        zoomLevel.value -= 0.25;
    }
};

const resetZoom = () => {
    zoomLevel.value = 1;
    panX.value = 0;
    panY.value = 0;
};

const handleZoom = (e) => {
    const delta = e.deltaY > 0 ? -0.25 : 0.25;
    const newZoom = zoomLevel.value + delta;

    if (newZoom >= 0.5 && newZoom <= 3) {
        zoomLevel.value = newZoom;
    }
};

const startPan = (e) => {
    if (zoomLevel.value > 1) {
        isPanning.value = true;
        lastPanX.value = e.clientX;
        lastPanY.value = e.clientY;
    }
};

const pan = (e) => {
    if (isPanning.value && zoomLevel.value > 1) {
        const deltaX = e.clientX - lastPanX.value;
        const deltaY = e.clientY - lastPanY.value;

        panX.value += deltaX;
        panY.value += deltaY;

        lastPanX.value = e.clientX;
        lastPanY.value = e.clientY;
    }
};

const stopPan = () => {
    isPanning.value = false;
};
</script>

<style scoped></style>
